export function getNotificationList(state) {
    return state.NotificationReducer.notifications;
}
